import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})

/* Types */
export const GET_GENERAL_INFO = 'GET_GENERAL_INFO'

export const PERSIST_GENERAL_INFO = 'PERSIST_GENERAL_INFO'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_GENERAL_INFO:
			return new Immutable.Map(action.dataObj)
		case PERSIST_GENERAL_INFO:
			return state.set('persisted', action.persisted)
		default:
			return state;
	}
};

/* Action Creators */

export const getGeneralInfo = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n})
		}).request().then(response => {
			dispatch(isLoading(false));

			response.data = Utils.ds_(response.data.reference)

			let info = response.data.informacionGeneral
			let dataObj = {
				granteeName: response.data.nombreDonataria,
				cluni: info.cluni,
				constitutionDate: info.fechaConstitucion,
				operationsDate: info.fechaInicioOperacion,
				iap: info.transformadaIAP,
				jap: info.organismoRegulador.id,
				socialIntervention: info.intervencionSocial,
				phone: info.telefono,
				webpage: info.paginaWeb||'',
				mail1: info.correoElectronico[0],
				mail2: info.correoElectronico[1]||'',
				twitter: info.twitter||'',
				facebook: info.facebook||'',
				persisted: false,
				checkInfo: response.data.recibeInfoNMP
			}
			dispatch({type: GET_GENERAL_INFO, dataObj })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setGeneralInfo = (form) => {

	let correoElectronico = [ form.mail1 ]
	form.mail2 && correoElectronico.push(form.mail2)

	form = {
		idDonataria: form.idDonataria,
		nombreDonataria: form.granteeName,
		recibeInfoNMP: !form.checkInfo ? false : form.checkInfo,
		informacionGeneral: {
			cluni: form.cluni,
			fechaConstitucion: form.constitutionDate.slice(0,10),
			fechaInicioOperacion: form.operationsDate.slice(0,10),
			transformadaIAP: form.iap,
			organismoRegulador: form.jap,
			intervencionSocial: form.socialIntervention,
			telefono: Number(form.phone),
			paginaWeb: form.webpage || undefined,
			correoElectronico,
			facebook: form.facebook || undefined,
			twitter: form.twitter || undefined
		}
	}

	form = { reference: Utils.ec_(form) }

	return (dispatch) => {
		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setInfoGeneral',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid, "n": localStorage.n})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({type: PERSIST_GENERAL_INFO, persisted: true })
			dispatch({type: PERSIST_GENERAL_INFO, persisted: false })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearGeneralInfo = () => {

	return (dispatch) => {
		dispatch({ type: GET_GENERAL_INFO, Obj: {} })
	}
}
// pendiente encriptar con llave de usuario desde el middleware


// WEBPACK FOOTER //
// ./src/modules/Grantees/Register/GeneralInfo.js